'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Header, Trigger } from '@radix-ui/react-accordion';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const AccordionAction = forwardRef(({ className, children, ...props }, ref) => (_jsx(Header, { className: "flex", children: _jsx(Trigger, { ref: ref, className: cn('flex flex-1 select-none items-center justify-between px-6 py-5 transition-all [&[data-state=open]>span>svg>rect]:!rotate-180 [&[data-state=open]>span]:rotate-180 [&[data-state=open]>svg>rect]:!rotate-180 [&[data-state=open]>svg]:rotate-180', className), ...props, children: children }) })));
AccordionAction.displayName = Trigger.displayName;
export { AccordionAction };
